import request from '@/utils/request'

// 获取用户地址
export const getUserAddress = function (data) {
    return request({
        url: '/v1/user/address',
        method: 'post',
        data: data
    })
}

// 获取用户地址
export const getInfoAddress = function (data) {
    return request({
        url: '/v1/user/infoAddress',
        method: 'post',
        data: data
    })
}

// 删除用户地址
export const delUserAddress = function (data) {
    return request({
        url: '/v1/user/delAddress',
        method: 'post',
        data: data
    })
}

export const getUserMoney = function (data) {
    return request({
        url: '/v1/user/getUserMoneyNew',
        method: 'post',
        data: data
    })
}
//
export const getDreMoney = function (data) {
    return request({
        url: '/v1/user/getDreMoney',
        method: 'post',
        data: data
    })
}
// 用户分享图
export const getUserShare = function (data) {
    return request({
        url: '/v1/user/share',
        method: 'post',
        data: data
    })
}

export const recharge = function (data) {
    return request({
        url: '/v1/user/rechargeNew',
        method: 'post',
        data: data
    })
}
// 活动奖励领取
export const activity = function (data) {
    return request({
        url: '/v1/user/activity',
        method: 'post',
        data: data
    })
}// 粉丝活动奖励领取
export const activity_fs = function (data) {
    return request({
        url: '/v1/user/activity_fs',
        method: 'post',
        data: data
    })
}

export const sendDre = function (data) {
    return request({
        url: '/v1/user/sendDre',
        method: 'post',
        data: data
    })
}

export const getDre = function (data) {
    return request({
        url: '/v1/user/getDre',
        method: 'post',
        data: data
    })
}

export const getDreCount = function (data) {
    return request({
        url: '/v1/user/getDreCount',
        method: 'post',
        data: data
    })
}

export const getGroupApply = function (data) {
    return request({
        url: '/v1/user/getGroupApply',
        method: 'post',
        data: data
    })
}

export default {
    getUserAddress,
    delUserAddress,
    getInfoAddress,

    getUserMoney,
    getDreMoney,
    getUserShare,
    recharge,
    activity,
    activity_fs,

    sendDre,
    getDre,
    getDreCount,
    getGroupApply
}
